import { compose } from 'ramda';
import { branch, mapProps } from 'recompose';
import { usePortletConfig } from 'js/components/system/Portlet';
import { RACES_ORDER } from './constants';
import { endingFirst, joinedFirst, onAirFirst, startingFirst, upcomingFirst } from '../helpers';

export default compose(
    branch(
        ({ leaderboards }) => Boolean(leaderboards),
        mapProps(
            ({ leaderboards: lbs }) => {
                const { racesOrder = '' } = usePortletConfig();
                const leaderboards = [...lbs];

                switch (racesOrder) {
                    case RACES_ORDER.raceStatus:
                        leaderboards.sort(onAirFirst);
                        break;
                    case RACES_ORDER.playerJoinStatus:
                        leaderboards.sort(joinedFirst);
                        break;
                    case RACES_ORDER.endDate:
                        leaderboards.sort(endingFirst);
                        break;
                    default:
                        leaderboards.sort(startingFirst).sort(upcomingFirst);
                        break;
                }

                return {
                    leaderboards
                };
            }
        )
    )
);
